
function formatNumber(num) {
      return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function checkQuestionPicked(obj = '{}', key, value) {
      try {
        if (obj == '' || obj == null || obj == undefined) return false
        parsedObj = JSON.parse(obj.replaceAll("=>", ":"))
        // Check if obj is an object and has the specified key
        if (typeof parsedObj === 'object' && parsedObj !== null && key in parsedObj) {
            return parsedObj[key] == value; // Return true or false based on value
        }
        return false; // Return false if obj is empty or key doesn't exist
      } catch (e) {
        console.log("error", e)
        return false
      }
    }  

    async function fetchProxy(request, method = 'GET', data = null) {
      const appProxy = '/apps/cpw-connect'
      try {
        let res =  await fetch( appProxy + '/tradein', {
          method: "POST", 
          body: JSON.stringify({
            endpoint: '/api/v1' + request,
            method: method,
            data: data
          })
        })
        const response = await res.json();
        if ("b636cd9c-c9cd-4ac0-9a14-79d3a8813de8" != "" && "https://b2bapi-partner.compasia.com/api/v1" != "" && res.status != 200) {
          let res =  await fetch( 'https://b2bapi-partner.compasia.com/api/v1' + request, {
            method: method, 
            headers: {
              "X-API-KEY": "b636cd9c-c9cd-4ac0-9a14-79d3a8813de8",
              "Content-Type": "application/json"
            },
            body: data ? JSON.stringify(data): null
          })
          const response = await res.json();
          return response.data || response
        }
        return response.data || response
    } catch(e) {
          let res =  await fetch( 'https://b2bapi-partner.compasia.com/api/v1' + request, {
            method: method, 
            headers: {
              "X-API-KEY": "b636cd9c-c9cd-4ac0-9a14-79d3a8813de8",
              "Content-Type": "application/json"
            },
            body: data ? JSON.stringify(data): null
          })
          const response = await res.json();
          return response.data || response
        }
    }

    function translateTradein(content) {

    if (Shopify.locale == 'en') return content
      const swapValue= {
        'is your device free of any locks? (passcode, find my, apple id/google account, remote management lock)': 'อุปกรณ์ที่ต้องการ Trade-in ไม่ถูกล๊อคใดๆใช่หรือไม่',
        'yes': 'ใช่',
        'no': 'ไม่',
        'what is your device lcd & screen condition?': 'สภาพจอ LCD / หน้าจอ เป็นอย่างไร?',
        'flawless': 'ไม่มีตำหนิ',
        '2-3 minor scratches': '2-3 รอยเล็กๆ',
        'heavy scratches': 'รอยลึก',
        'cracked': 'รอยแตก',
        'not working ': 'จอไม่ทำงาน',
        'lcd lines, burns, shadow, dead pixels, unresponsive)': 'LCD เป็นเส้น, จอเบิร์น, เป็นเงา, มีจุดสีที่จอ, ระบบสัมผัสที่จอไม่ทำงาน)',
        'not working (lcd lines, burns, shadow, dead pixels, unresponsive)': 'จอไม่ทำงาน (LCD เป็นเส้น, จอเบิร์น, เป็นเงา, มีจุดสีที่จอ, ระบบสัมผัสที่จอไม่ทำงาน)',
        'what is your device body condition (back and side)?': 'สภาพตัวเครื่องด้านหลังและด้านข้างเป็นอย่างไร?',
        'dented': 'บิ่น',
        'is your device fingerprint/face id working ?': 'ระบบสแกนลายนิ้วมือ / สแกนใบหน้าทำงานหรือไม่?',
        'are all the device functions below working fine? (speakers, microphone, buttons, wifi, bluetooth)': 'ฟังก์ชันต่างๆในเครื่องทำงานปกติหรือไม่(ลำโพง, ไมโครโฟน, ปุ่มกดม Wi-Fi, บูลทูธ)',
        'are both the front and back cameras of your device working as intended?': 'กล้องหน้าและกล้องหลังทำงานปกติใช่หรือไม่ ?',
        'does your device have the below issue?': 'อุปกรณ์ของคุณมีปัญหาดังต่อไปนี้หรือไม่?',
        'bloated battery/screen or body pop out': 'แบตบวมแบตเตอรี่ / หน้าจอหลุดออกมา',
        'liquid damage': 'เป็นคราบน้ำ',
        'device cannot turn on/datawipe': 'เครื่องไม่สามารถเปิด หรือล้างข้อมูลได้',
        'non-genuine parts/ missing parts': 'อะไหล่ไม่ใช่ของแท้/ ชิ้นส่วนหายไป',
        'jailbroken or rooted devices': 'การละเมิดลิขสิทธิ์ซอฟต์แวร์',
        'none of the above': 'ไม่มี',
        'single choice': 'single choice',
        'multiple choices': 'multiple choices',
        'select option': 'เลือกรุ่น',
        'trade in': 'Trade-in เก่าแลกใหม่',
        'brand': 'แบรนด์',
        'model': 'รุ่น',
        'imei': 'หมายเลขเครื่อง',
        'bank account number': 'เลขบัญชีของคุณ',
        'bank name': 'ชื่อธนาคาร',
        'bank account name': 'ชื่อบัญชีของคุณ',
        'imei number': 'หมายเลขเครื่อง',
        'invalid imei': "IMEI ไม่ถูกต้อง"
      }
      translatedContent = swapValue[content.toLowerCase()] || content
      
      return translatedContent
    }

    function addOption(data, optionValue, optionName, select, selectedValue = null, optional = '') {
      data.map(i => {
        let option = document.createElement('option')
        option.value = i[optionValue]
        option.dataset.value = i[optionName]
        option.innerHTML = i[optionName] + (optional && ' ' + i[optional])
        if (selectedValue == i[optionValue] || selectedValue == i[optionName]) {
          option.selected = true
        }
        select.appendChild(option)
      })
    }

    function removeAllOptionExceptFirst(arr) {
      arr.forEach(i => {
        i.selectedIndex = 0;
        $(i).find('option:not(:first-child)').remove()
      })
    }

    function initTradein() {
        const $tradeInModals = document.querySelectorAll('.trade-in__modal-content:not(.imei-step)');
        $tradeInModals.forEach( async ($modal) => {
          const $modalStep1Id = $modal.id.replace("tradeIn-step-1-", "")
          const $modalStep2 = document.querySelector(`.trade-in__modal-content[data-step-2='${$modalStep1Id}']`)
          
          const $triggerStep2Button = $modal.querySelector('.js-trade-in-modal-step2-trigger');

          // const $tradeInSelectMenus = $modal.querySelectorAll('.trade-in__modal-content .select');
          const $tradeInSurveyForm = $modal.querySelector('.trade-in__modal-content #tradein-form[data-step-2] .form-container');

          const renderedQuestion = $tradeInSurveyForm.querySelectorAll(".question_tradein--container input")

          const $tradeInValueAmounts = document.querySelectorAll('.js-trade-in-value-amount');
          const $tradeInSelected = $modal.querySelector(".trade_in__modal--selected-device")
          const $tradeInAddBtn =
            $modalStep2.querySelector('.trade-in__modal-content .js-add-to-product') ||
            $modalStep2.querySelector('.trade-in__modal-content .add-cart-trade-in');
            
          if (renderedQuestion.length == 0) {
            $tradeInAddBtn.setAttribute('disabled', 'disabled')
            $triggerStep2Button.setAttribute("disabled", 'disabled')
          }

          //Step1_DEVICE select
          const categorySelect = $modal.querySelector(".type-select .select")
          const brandSelect = $modal.querySelector(".brand-select .select")
          const modelSelect = $modal.querySelector(".model-select .select")
          const deviceSelect = $modal.querySelector(".device-select .select")
          const brandContainer = $modal.querySelector(".brand-select")
          const modelContainer = $modal.querySelector(".model-select")
          const deviceContainer  = $modal.querySelector(".device-select")
          const step1_next_button = $modal.querySelector(".question-trigger");
          const step2_prev_button = $modal.querySelector(".rollback-device-trigger");
          const step2_next_button = $modal.querySelector(".validate-imei-trigger");
          let { tradeInCategory, tradeinBrand_id, tradeinModel_id, tradeinDevice, diagnosticQuery = '{}', transferType, store, bank } = $tradeInSelected.dataset

          // Render category
          const category = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-category`)
          if (categorySelect.options.length <= 1) addOption(category, 'productCategoryId', 'productCategoryName', categorySelect, tradeInCategory)
          

          // Handle Case when loading edit tradein
          if (tradeInCategory && tradeInCategory != '' && tradeinBrand_id && tradeinModel_id && tradeinDevice) {
            // Render brand
            const brandGet = fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-group?productCategoryId=${tradeInCategory}`)
            const modelGet = fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-model?productGroupId=${tradeinBrand_id}`) 
            const productVariantGet = fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-variant?productId=${tradeinModel_id}`)
            const questionListGet = fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/diagnostic/diagnostic-list?productVariantId=${tradeinDevice}` , "GET")


            const [ brand, model, productVariant, questionList] = await Promise.all([ brandGet, modelGet, productVariantGet, questionListGet]);
            if (brandSelect.options.length <= 1) addOption(brand, 'productGroupId', 'productGroupName', brandSelect, tradeinBrand_id)

            //Render model
            brandContainer.classList.remove("no-js")
            modelContainer.classList.remove("no-js")
            if (modelSelect.options.length <= 1) addOption(model, 'productId', 'productName', modelSelect, tradeinModel_id)

             //Select device
            deviceContainer.classList.remove("no-js")
            if (deviceSelect.options.length <= 1) addOption(productVariant, 'productVariantId', 'productFullName', deviceSelect, tradeinDevice)

            let questionContainer = `<ol class="list_question_tradein">`
            questionList.diagnosticChecklists.map(i => {
                var random_uniq = Date.now().toString(36) + Math.random().toString(36).slice(2);
                questionContainer += `<li class="question_tradein--container ${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? 'single-choice': 'multiple-choice'}">
                  <div class="question__tradein--wrapper">
                    <h4 class="form__label form__label__bold">${translateTradein(i.diagnosticFunctionalityName)}<span style="color:#f1f1f1;margin-left: 5px;"> ${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? 'single-choice': 'multiple-choice'}</span></h4>
                    <div class="list-answer-tradein product-form__input product-form__input--trade-in">
                    ${i.diagnosticOptionGroup.diagnosticOptions.map((ans, index) => `<div class="answer-option-tradein">
                        <input type="radio" data-multiply="${i.diagnosticOptionGroup.diagnosticOptionGroupType === "multiple"}" ${ checkQuestionPicked( diagnosticQuery, i.diagnosticChecklistCode, ans.diagnosticOptionCode) ?  'checked': ''} id="${i.diagnosticFunctionalityCode}_${index}_${random_uniq}" value="${translateTradein(ans.diagnosticOptionName)}" data-value="${ans.diagnosticOptionCode}" data-code="${i.diagnosticChecklistCode}" data-type="${i.diagnosticFunctionalityCode}" name="${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? i.diagnosticFunctionalityCode: i.diagnosticFunctionalityCode + index}" >
                        <label data-option="no-color" data-title="Yes" data-noproduct="" class="answer-tradein" for="${i.diagnosticFunctionalityCode}_${index}_${random_uniq}" ${ans.diagnosticOptionName.indexOf("(") > -1 && 'data-long'}>
                          ${ans.diagnosticOptionName.indexOf("(") > -1 ? translateTradein(ans.diagnosticOptionName.split('(')[0]) + '<span style="font-size:9px;  font-size-adjust: 0.35;">(' + translateTradein(ans.diagnosticOptionName.split('(')[1]) + '</span>': translateTradein(ans.diagnosticOptionName)}
                        </label>
                      </div>`
                    ).join('')}
                    </div>
                  </div>
                </li>`
            })
            questionContainer += `</ol>`
            if ($tradeInSurveyForm) {
              $tradeInSurveyForm.innerHTML = questionContainer
            }
       
            //Attach popup
            const renderedSingleQuestion = $tradeInSurveyForm.querySelectorAll(".question_tradein--container.single-choice input")
            const renderedMultipleQuestion = $tradeInSurveyForm.querySelectorAll(".question_tradein--container.multiple-choice input")
            renderedSingleQuestion.forEach(single => {
              single.addEventListener('change', (e) => handleSingleChoiceQuestion(e))
            })

            // Handle for multiple choice option
            renderedMultipleQuestion.forEach(multiple => {
              multiple.addEventListener('change', (e) =>  handleMultipleChoiceQuestion(e))
            })
            $tradeInAddBtn.setAttribute('data-trade-in-device_id', tradeinDevice)
            step1_next_button.removeAttribute("disabled")
            step2_next_button.removeAttribute("disabled")
            $tradeInAddBtn.removeAttribute("disabled")
          }

          categorySelect.addEventListener('change', async (e) => {
            brandContainer.classList.remove("no-js")
            categorySelect.setAttribute("disabled", 'disabled')
            brandSelect.classList.add('select-spinner')
            removeAllOptionExceptFirst([brandSelect, modelSelect, deviceSelect])
            const brand = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-group?productCategoryId=${e.target.value}`) 
            if (brandSelect.options.length <= 1) addOption(brand, 'productGroupId', 'productGroupName', brandSelect)
            $tradeInAddBtn.setAttribute("data-trade-in-device_category", e.target.value)
            step1_next_button.setAttribute("disabled", 'disabled')
            brandSelect.classList.remove('select-spinner')
            categorySelect.removeAttribute("disabled")
            $modal.querySelector(".default-error").innerHTML = ""
          })
          categorySelect.classList.remove('select-spinner')

          brandSelect.addEventListener('change', async (e) => {
            modelContainer.classList.remove("no-js") 
            categorySelect.setAttribute("disabled", 'disabled')
            brandSelect.setAttribute("disabled", 'disabled')        
            $modalStep2.querySelector(".step-2-brand").value = e.target.options[e.target.selectedIndex].getAttribute("data-value")
            modelSelect.classList.add('select-spinner')
            removeAllOptionExceptFirst([modelSelect, deviceSelect])
            const model = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-model?productGroupId=${e.target.value}`) 
            if (modelSelect.options.length <= 1) addOption(model, 'productId', 'productName', modelSelect)
            modelSelect.classList.remove('select-spinner')
            $tradeInAddBtn.setAttribute("data-trade-in-device_brand", e.target.options[e.target.selectedIndex].getAttribute("data-value"))
            $tradeInAddBtn.setAttribute("data-trade-in-device_brand_id", e.target.value)
            step1_next_button.setAttribute("disabled", 'disabled')
            categorySelect.removeAttribute("disabled")
            brandSelect.removeAttribute("disabled")
            $modal.querySelector(".default-error").innerHTML = ""
          })

          modelSelect.addEventListener('change', async (e) => {
            deviceContainer.classList.remove("no-js")    
            categorySelect.setAttribute("disabled", 'disabled')
            brandSelect.setAttribute("disabled", 'disabled')
            modelSelect.setAttribute("disabled", 'disabled')
            deviceSelect.classList.add('select-spinner')       
            $modalStep2.querySelector(".step-2-model").value = e.target.options[e.target.selectedIndex].getAttribute("data-value")
            removeAllOptionExceptFirst([deviceSelect])
            const productVariant = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-variant?productId=${e.target.value}`)
            if (deviceSelect.options.length <= 1) addOption(productVariant, 'productVariantId', 'productFullName', deviceSelect)
            $tradeInAddBtn.setAttribute("data-trade-in-device_model", e.target.options[e.target.selectedIndex].getAttribute("data-value"))
            $tradeInAddBtn.setAttribute("data-trade-in-device_model_id", e.target.value)
            step1_next_button.setAttribute("disabled", 'disabled')
            deviceSelect.classList.remove('select-spinner')
            categorySelect.removeAttribute("disabled")
            brandSelect.removeAttribute("disabled")
            modelSelect.removeAttribute("disabled")
            $modal.querySelector(".default-error").innerHTML = ""
          })

          deviceSelect.addEventListener('change', async (e) => {
            $tradeInAddBtn.setAttribute("data-trade-in-device", e.target.value)
            step1_next_button.classList.add('loading')
            const selected_options = e.target.options[e.target.selectedIndex]
            $tradeInSelected.innerHTML = selected_options.getAttribute("data-value")
            $tradeInAddBtn.setAttribute("data-trade-in-device", selected_options.getAttribute("data-value"))
            $tradeInAddBtn.setAttribute('data-trade-in-device_id', e.target.value);
            // Make sure that button is disabled when change device
            step2_next_button.setAttribute("disabled", "disabled")
            const questionList = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/diagnostic/diagnostic-list?productVariantId=${e.target.value}` , "GET")
            if (questionList?.statusCode) {
              step1_next_button.classList.remove('loading');
              step1_next_button.setAttribute("disabled", "disabled")
              $modal.querySelector(".default-error").innerHTML = "You cannot select this device for trade-in"
              return
            }
            
              let questionContainer = `<ol class="list_question_tradein">`
              questionList.diagnosticChecklists.map(i => {
                  var random_uniq = Date.now().toString(36) + Math.random().toString(36).slice(2);
                  questionContainer += `<li class="question_tradein--container ${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? 'single-choice': 'multiple-choice'}">
                    <div class="question__tradein--wrapper">
                      <h4 class="form__label form__label__bold">${translateTradein(i.diagnosticFunctionalityName)}<span style="color:#f1f1f1;margin-left: 5px;"> ${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? 'single-choice': 'multiple-choice'}</span></h4>
                      <div class="list-answer-tradein product-form__input product-form__input--trade-in">
                      ${i.diagnosticOptionGroup.diagnosticOptions.map((ans, index) => `<div class="answer-option-tradein">
                          <input type="radio" data-multiply="${i.diagnosticOptionGroup.diagnosticOptionGroupType === "multiple"}" ${ checkQuestionPicked( diagnosticQuery, i.diagnosticFunctionalityCode, ans.diagnosticOptionCode) ?  'checked': ''} id="${i.diagnosticFunctionalityCode}_${index}_${random_uniq}" value="${translateTradein(ans.diagnosticOptionName)}" data-value="${ans.diagnosticOptionCode}" data-code="${i.diagnosticChecklistCode}" data-type="${i.diagnosticFunctionalityCode}" name="${i.diagnosticOptionGroup.diagnosticOptionGroupType ==='single'? i.diagnosticFunctionalityCode: i.diagnosticFunctionalityCode + index}" >
                          <label data-option="no-color" data-title="Yes" data-noproduct="" class="answer-tradein" for="${i.diagnosticFunctionalityCode}_${index}_${random_uniq}" ${ans.diagnosticOptionName.indexOf("(") > -1 && 'data-long'}>
                            ${ans.diagnosticOptionName.indexOf("(") > -1 ? translateTradein(ans.diagnosticOptionName.split('(')[0]) + '<span style="font-size:9px;  font-size-adjust: 0.35;">(' + translateTradein(ans.diagnosticOptionName.split('(')[1]) + '</span>': translateTradein(ans.diagnosticOptionName)}
                          </label>
                        </div>`
                      ).join('')}
                      </div>
                    </div>
                  </li>`
              })
              questionContainer += `</ol>`
              if ($tradeInSurveyForm) {
                $tradeInSurveyForm.innerHTML = questionContainer
              }
       
            //Attach popup
            const renderedSingleQuestion = $tradeInSurveyForm.querySelectorAll(".question_tradein--container.single-choice input")
            const renderedMultipleQuestion = $tradeInSurveyForm.querySelectorAll(".question_tradein--container.multiple-choice input")
            renderedSingleQuestion.forEach(single => {
              single.addEventListener('change', (e) => handleSingleChoiceQuestion(e))
            })

            // Handle for multiple choice option
            renderedMultipleQuestion.forEach(multiple => {
              multiple.addEventListener('change', (e) =>  handleMultipleChoiceQuestion(e))
            })
            step1_next_button.removeAttribute("disabled")
            step1_next_button.classList.remove('loading')
          })

          step1_next_button.addEventListener("click", async () => {
            $modal.querySelector('[data-step-1]').classList.add("no-js")
            $modal.querySelector('[data-step-2]').classList.remove("no-js")
          })


          step2_prev_button.addEventListener("click", async () => {
            $modal.querySelector('[data-step-1]').classList.remove("no-js")
            $modal.querySelector('[data-step-2]').classList.add("no-js")
          })


          step2_next_button.addEventListener("click", async () => {
            step2_next_button.classList.add("loading")
            const checkedInputs = $modal.querySelectorAll('input[type="radio"]:checked');
            const mappedAnswer = {};

            checkedInputs.forEach(input => {
                const code = input.getAttribute('data-code');
                const value = input.getAttribute('data-value');
                const multiply = input.getAttribute("data-multiply")

                // Check if the code already exists in the mappedAnswer object
                if (mappedAnswer[code]) {
                    // If it's already an array, push the new value
                    if (Array.isArray(mappedAnswer[code])) {
                        mappedAnswer[code].push(value);
                    } else {
                        // If it's a single value, convert it into an array
                        mappedAnswer[code] = [mappedAnswer[code], value];
                    }
                } else {
                    // If it doesn't exist, create a new entry
                  if (multiply == 'true') {
                    mappedAnswer[code] = [value]
                  } else {
                    mappedAnswer[code] = value;
                  }
                }
            });

            const tradeInDeviceDiagnostic = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/diagnostic/device-diagnostic-result`, 'POST', {
              "productVariantId": parseInt($tradeInAddBtn.getAttribute('data-trade-in-device_id')),
              "diagnosticResult": mappedAnswer
            })

            $modal.querySelector(".imei-form--quote-price #quotedPriceText").innerHTML = formatNumber(parseInt(tradeInDeviceDiagnostic.quotedPrice))
            $tradeInAddBtn.setAttribute("data-trade-in-diagnostic", tradeInDeviceDiagnostic.deviceDiagnosticUuid)
            $tradeInAddBtn.setAttribute("data-trade-in-diagnostic-query", JSON.stringify(mappedAnswer))
            $tradeInAddBtn.setAttribute("data-trade-in-device_value", tradeInDeviceDiagnostic.quotedPrice)


            step2_next_button.classList.remove("loading")
            $modal.querySelector('[data-step-2]').classList.add("no-js")
            $modal.querySelector('[data-step-3]').classList.remove("no-js")
            $modal.querySelector(".rollback-imei-trigger").classList.remove('no-js')
            $modal.querySelector('.fake-trigger').classList.remove("no-js")
            // Handle Case from edit tradein
            if ($modal.querySelector('#imeiInput').value) {
              $modal.querySelector('.fake-trigger').removeAttribute("disabled"), $triggerStep2Button.removeAttribute('disabled')
            }
          })

          $modal.querySelector(".rollback-imei-trigger").addEventListener("click", () => {
            $modal.querySelector('[data-step-2]').classList.remove("no-js")
            $modal.querySelector('[data-step-3]').classList.add("no-js")
            $modal.querySelector(".rollback-imei-trigger").classList.add('no-js')
            $modal.querySelector('.fake-trigger').classList.add("no-js")
          })

          const handleSingleChoiceQuestion =  (button) => {
            $tradeInAddBtn.setAttribute(`data-trade-in-${button.target.getAttribute("data-type")}`, button.target.value )
            // Check to enable add TradeIn btn
            button.target.closest('.question_tradein--container').classList.add('checked')
            if ($tradeInSurveyForm.querySelectorAll('.question_tradein--container:not(.checked)').length == 0) {
              step2_next_button.removeAttribute("disabled")
            }
          }

          const handleMultipleChoiceQuestion = (button) => {
            if(button.target.value === "None of the above" || button.target.value === "ไม่มี") {
              $tradeInAddBtn.setAttribute(`data-trade-in-${button.target.getAttribute("data-type")}`, button.target.value )
              const other_answer = $tradeInSurveyForm.querySelectorAll(`input[data-type=${button.target.getAttribute("data-type")}]`)
              other_answer.forEach(answer => answer.checked = false)
              button.target.checked = true;
            } else {
              const current_choice_value = $tradeInAddBtn.getAttribute(`data-trade-in-${button.target.getAttribute("data-type")}`)
              $tradeInAddBtn.setAttribute(`data-trade-in-${button.target.getAttribute("data-type")}`, current_choice_value && (current_choice_value !== "None of the above" && current_choice_value !== "ไม่มี") ? current_choice_value + ', ' + button.target.value : button.target.value)
              const nil_answer = $tradeInSurveyForm.querySelector(`input[value="None of the above"]`) || $tradeInSurveyForm.querySelector(`input[value="ไม่มี"]`)
              nil_answer.checked = false
            }
            // Check to enable add TradeIn btn
            button.target.closest('.question_tradein--container').classList.add('checked')
            if ($tradeInSurveyForm.querySelectorAll('.question_tradein--container:not(.checked)').length == 0) {
              step2_next_button.removeAttribute("disabled")
            }
          }

          $modal.querySelector('#imeiInput').addEventListener('input', async (e) => {
            if (!e.target.value || e.target.value == '') {
              $triggerStep2Button.setAttribute('disabled', 'disabled')
              $modal.querySelector('.fake-trigger').setAttribute('disabled', 'disabled')
              return
            }

            if (e.target.length > 15) {
              $modal.querySelector(".imei-error").innerHTML = "Invalid IMEI"
              return;
            }
            $triggerStep2Button.removeAttribute("disabled")
            $modal.querySelector('.fake-trigger').removeAttribute("disabled")
            $tradeInAddBtn.setAttribute('data-trade-in-imei',e.target.value)
          })
          

          $modal.querySelector('.fake-trigger').addEventListener('click', async (e) => {
            //Update attribute and render to 2nd modal
            e.target.classList.add("loading")
            const getImei = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/imei/${$tradeInAddBtn.getAttribute("data-trade-in-imei") || $tradeInAddBtn.value}/validate/productVariantId/${$tradeInAddBtn.getAttribute("data-trade-in-device_id")}`)
            if (getImei?.statusCode) {
              var message = null
              if (Array.isArray(getImei.message)) {
                message = getImei.message.join("; ");
              } else if (getImei.message instanceof String || typeof getImei.message === "string") {
                message = getImei.message;
              } else {
                message = getImei.message.EN;
              }
              e.target.classList.remove("loading")

              $modal.querySelector(".imei-error").innerHTML = translateTradein(message)
              return
            }
            $modal.querySelector(".imei-error").innerHTML = ''
            $triggerStep2Button.click();
            $($modal).closest('.modal-overlay').find('button.modal-close-button').click()
            const getListStore = fetchProxy('/smart-exchange/integration-c2b-b2b-microsite/dropoff/dropoff-store')
            const getBankList = fetchProxy('/smart-exchange/integration-c2b-b2b-microsite/bank/bank-list')
            const getDeviceList = fetchProxy('/smart-exchange/integration-c2b-b2b-microsite/product/trade-up/product-list')
            const [ storeList, bankList, deviceList] = await Promise.all([ getListStore, getBankList, getDeviceList]);
            
            e.target.classList.remove("loading")


            if ($modalStep2.querySelector("[name='data-trade-in-bank_name']").options.length <= 1) addOption(bankList, 'bankId', 'bankName', $modalStep2.querySelector('.bank_list'), bank)
            if ($modalStep2.querySelector("[name='data-trade-in-dropoff-store']").options.length <= 1) addOption(storeList, 'dropoffStoreId', 'storeName', $modalStep2.querySelector('[name="data-trade-in-dropoff-store"]'), store,'address')
            const device = $tradeInAddBtn.getAttribute("data-trade-in-device")
            const selectedDevice = deviceList.find(x => x.productName === device)?.tradeUpId || $modal.getAttribute("data-tradeup-id") || $tradeInSelected.getAttribute("data-tradeup-id");
            let topUpValue = 0
            $tradeInAddBtn.setAttribute('data-trade-in-top-up-id', '')
            $tradeInAddBtn.setAttribute('data-trade-in-device_trade-up', '')
            const getTopUp = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/voucher/eligible-voucher?deviceDiagnosticUuid=${$tradeInAddBtn.getAttribute("data-trade-in-diagnostic")}&tradeUpId=${selectedDevice}`)
          
            if (getTopUp != null) {
              topUpValue = getTopUp.amount
              $tradeInAddBtn.setAttribute('data-trade-in-device_trade-up', selectedDevice)
              $tradeInAddBtn.setAttribute('data-trade-in-top-up-id', getTopUp.voucherId)
              $tradeInAddBtn.setAttribute('data-trade-in-top-up', topUpValue || 0)
            }


            // if (document.querySelector('.trade-in__pdp-description span')) document.querySelector('.trade-in__pdp-description span').innerHTML = '฿' +formatNumber(parseInt(selected_options.getAttribute("data-price")))
            // $modal.querySelector('.description span').innerHTML = '฿' +formatNumber(parseInt(selected_options.getAttribute("data-price")) + parseInt(selected_options.getAttribute("data-topup") || 0))
          });


          // Check if empty input
          const isEveryInputEmpty = () => {
              var inputs = $modalStep2.querySelectorAll('input.tradein-step2-input, .select');
              for (const input of inputs) {
                if (input.offsetWidth == 0 || input.offsetHeight == 0 || input.getClientRects().length == 0 || input.type == 'radio') {continue}
                if (!input.value || input.value == '') return false
              }
              return true;
          }

          // Validate continue input
          const $input =  $modalStep2.querySelectorAll('.tradein-step2-input').forEach( (i) => {
            i.addEventListener('input', debounce(async (e) => {
              const input = e.target
              $tradeInAddBtn.setAttribute(input.name, input.value)
              const noEmptyInput = isEveryInputEmpty();
              $tradeInAddBtn.setAttribute("disabled", "disabled")
              
              //Validate customer phone
              if (input.name == "data-trade-in-customer_phone") {
                var phone_error_input = $modalStep2.querySelector('.tradein-customer-phone-error')
                if (e.target.value.match("^[0-9]{1,10}$")) {       
                    phone_error_input.innerHTML = ""
                    localStorage.setItem(`${$modalStep1Id}_check_phone_validate`, true)
                } else {
                    phone_error_input.innerHTML = "This should contain only numbers and have a maximum of 10 digits"
                    localStorage.setItem(`${$modalStep1Id}_check_phone_validate`, false)
                }

                if (e.target.value.length > 10) {
                  phone_error_input.innerHTML = "This should contain only numbers and have a maximum of 10 digits"
                  localStorage.setItem(`${$modalStep1Id}_check_phone_validate`, false)
                }
              }

              //Validate bank number
              if (input.name == 'data-trade-in-bank_account_number') {
                  var bank_error_input = $modalStep2.querySelector('.tradein-bank-account-number-error')
                  if (e.target.value.match("^[0-9]+$")) {     
                    bank_error_input.innerHTML = ""
                    localStorage.setItem(`${$modalStep1Id}_check_bank_validate`, true)
                  } else {
                    bank_error_input.innerHTML = "This should contain only numbers"
                    localStorage.setItem(`${$modalStep1Id}_check_bank_validate`, false)
                  }

                  if (e.target.value == '') {
                    bank_error_input.innerHTML = "This cannot be empty"
                    localStorage.setItem(`${$modalStep1Id}_check_bank_validate`, false)
                  }

              }
              //Validate customer email
              if (input.name == 'data-trade-in-customer_email') {
                  var email_error_input = $modalStep2.querySelector('.tradein-customer-email-error')
                  if (e.target.value.match("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$")) {  
                    email_error_input.innerHTML = ""
                    localStorage.setItem(`${$modalStep1Id}_check_mail_validate`, true)
                  } else {
                    email_error_input.innerHTML = "Email address should have &#39;@&#39; followed by email provider"
                    localStorage.setItem(`${$modalStep1Id}_check_mail_validate`, false)
                  }

                  if (e.target.value == '') {
                    email_error_input.innerHTML = "This cannot be empty"
                    localStorage.setItem(`${$modalStep1Id}_check_mail_validate`, false)
                  }
              }

              if (input.name == 'data-trade-in-postcode') {
                const validated = await fetchProxy(`/smart-exchange/integration-c2b-b2b-microsite/region/postcode/${input.value}/validate`)
                if (validated.isValid == false) {
                  $modalStep2.querySelector('.postcode-error').classList.remove('no-js')
                  localStorage.setItem(`${$modalStep1Id}_check_postcode_validate`, false)
                } else {
                  $modalStep2.querySelector('.postcode-error').classList.add('no-js')
                  localStorage.setItem(`${$modalStep1Id}_check_postcode_validate`, true)
                }
              }

              if (noEmptyInput && ($tradeInAddBtn.getAttribute('data-trade-in-transfer-type') == 'dropoff' ? true : localStorage.getItem(`${$modalStep1Id}_check_postcode_validate`) != 'false') && localStorage.getItem(`${$modalStep1Id}_check_mail_validate`) != 'false' && localStorage.getItem(`${$modalStep1Id}_check_bank_validate`) != 'false'&& localStorage.getItem(`${$modalStep1Id}_check_phone_validate`) != 'false' ) {
                $tradeInAddBtn.removeAttribute("disabled")
              }
              if (document.querySelector( input.name.replace("#selected-", 'data-'))) document.querySelector(input.name.replace("#selected-", 'data-')).value = input.value
            }, 500))
          })

          if (transferType && transferType != '') {
            $tradeInAddBtn.setAttribute('data-trade-in-transfer-type', transferType)
          } else {
            $tradeInAddBtn.setAttribute('data-trade-in-transfer-type', 'dropoff')
          }

          //Handle radio select
          $modalStep2.querySelector(".tradein-transfer-type.dropoff").addEventListener('click', () => {
              $tradeInAddBtn.setAttribute('data-trade-in-transfer-type', 'dropoff')
              $modalStep2.querySelector('[data-type="pickup"]').classList.add('no-js')
              $modalStep2.querySelector('[data-type="dropoff"]').classList.remove('no-js')
              const noEmptyInput = isEveryInputEmpty();
              if (noEmptyInput && localStorage.getItem(`${$modalStep1Id}_check_mail_validate`) != 'false' && localStorage.getItem(`${$modalStep1Id}_check_bank_validate`) != 'false'&& localStorage.getItem(`${$modalStep1Id}_check_phone_validate`) != 'false') {
                $tradeInAddBtn.removeAttribute("disabled")
              } else {
                $tradeInAddBtn.setAttribute("disabled", "disabled")
              }
          })

          $modalStep2.querySelector(".tradein-transfer-type.pickup").addEventListener('click', () => {
              $tradeInAddBtn.setAttribute('data-trade-in-transfer-type', 'pickup')
              $modalStep2.querySelector('[data-type="pickup"]').classList.remove('no-js')
              $modalStep2.querySelector('[data-type="dropoff"]').classList.add('no-js')
              const noEmptyInput = isEveryInputEmpty();
              if (noEmptyInput && localStorage.getItem(`${$modalStep1Id}_check_postcode_validate`) != 'false' && localStorage.getItem(`${$modalStep1Id}_check_mail_validate`) != 'false' && localStorage.getItem(`${$modalStep1Id}_check_bank_validate`) != 'false'&& localStorage.getItem(`${$modalStep1Id}_check_phone_validate`) != 'false') {
                $tradeInAddBtn.removeAttribute("disabled")
              } else {
                $tradeInAddBtn.setAttribute("disabled", "disabled")
              }
          })

          const imei_form = $modalStep2.querySelector('.tradeIn-personal-info')
          //Phone validate

          $tradeInAddBtn.addEventListener('click', async (e) => {
            const { 
              tradeInDevice_id, 
              tradeInValue,  
              tradeInTopUp, 
              tradeInDevice, 
              tradeInDevice_condition, 
              tradeInCamera_both, 
              tradeInFingerprint_faceid, 
              tradeInDevice_functions, 
              tradeInPhone_locks, 
              tradeInDevice_locks, 
              tradeInLcd_screen, 
              tradeInDevice_sensors, 
              tradeInDevice_value,
              tradeInDevice_brand,
              tradeInDevice_model,
              tradeInDevice_brand_id,
              tradeInDevice_model_id,
              tradeInBank_account_name, 
              tradeInBank_name, 
              tradeInImei, 
              tradeInBank_account_number,
              tradeInDevice_category,
              tradeInTransferType,
              tradeInDiagnostic,
              tradeInDiagnosticQuery,
              tradeInTopUpId,
              tradeInPostcode,
              tradeInDropoffStore,
              tradeInCustomer_name,
              tradeInCustomer_email,
              tradeInCustomer_phone,
              tradeInDevice_tradeUp
            } = e.target.dataset;
            const surveyForm = e.target.dataset;




            let tradeInValueEstimated = tradeInDevice_value
            let tradeInDeviceValue = tradeInDevice_value


            tradeInValueEstimated = parseInt(tradeInDeviceValue) + parseInt(tradeInTopUp || 0)
            const tradeInPrice = document.querySelector(".trade-in__pdp-description span")
            if (tradeInPrice) {
              tradeInPrice.innerHTML = '฿' + formatNumber(tradeInValueEstimated)
            }

            const $selectedTradeInValue = document.querySelector('#selected-trade-in-value');
            const $selectedTradeInDevice = document.querySelector('#selected-trade-in-device');
            const selectors = [
              '#selected-trade-in-device_id',
              '#selected-trade-in-device_brand',
              '#selected-trade-in-device_model',
              '#selected-trade-in-device_brand_id',
              '#selected-trade-in-device_model_id',
              '#selected-trade-in-device_value',
              '#selected-trade-in-topup',
              '#selected-trade-in-bank-account-name',
              '#selected-trade-in-bank-name',
              '#selected-trade-in-device_category',
              '#selected-trade-in-imei',
              '#selected-trade-in-bank-account-number',
              '#selected-trade-in-diagnostic',
              '#selected-trade-in-diagnostic-query',
              '#selected-trade-in-transfer-type',
              '#selected-trade-in-topup-id',
              '#selected-trade-in-postcode',
              '#selected-trade-in-dropoff-store',
              '#selected-trade-in-customer-name',
              '#selected-trade-in-customer-email',
              '#selected-trade-in-customer-phone',
              '#selected-trade-in-device-trade-up'
            ];

            // Map of values to assign
            const values = [
              tradeInDevice_id,
              tradeInDevice_brand,
              tradeInDevice_model,
              tradeInDevice_brand_id,
              tradeInDevice_model_id,
              tradeInDevice_value,
              tradeInTopUp ||0,
              tradeInBank_account_name, 
              tradeInBank_name, 
              tradeInDevice_category,
              tradeInImei, 
              tradeInBank_account_number,
              tradeInDiagnostic,
              tradeInDiagnosticQuery,
              tradeInTransferType,
              tradeInTopUpId,
              tradeInPostcode,
              tradeInDropoffStore,
              tradeInCustomer_name,
              tradeInCustomer_email,
              tradeInCustomer_phone,
              tradeInDevice_tradeUp
            ];

            // Assign values to the selected elements
            selectors.forEach((selector, index) => {
              const element = document.querySelector(selector);
              if(element) element.value = values[index];
            });

            const $tradeInModal = document.getElementById('modal-trade-in-modal');
            const $tradeInModalStep2 = document.getElementById('modal-trade-in-modal-step2');
            const $tradeInModalParent = $tradeInModal?.parentElement;
            const $tradeInModalCloseBtn = $tradeInModalParent?.nextElementSibling;
            const $tradeInModalCloseBtn2  = $tradeInModalStep2?.parentElement?.nextElementSibling;

            const $startTradeInBtn = document.querySelector('.js-product-option-form .js-trade-in-modal-trigger-input');
            const $startTradeInBtnLabel = document.querySelector(
              '.js-product-option-form .js-trade-in-modal-trigger-input + label'
            );
            const $productPrices = document.querySelectorAll('.js-product-price-with-care-warranty');
            if ($selectedTradeInValue && $selectedTradeInDevice && $tradeInModalCloseBtn) {
              $selectedTradeInValue.value = tradeInValueEstimated;
              $selectedTradeInDevice.value = tradeInDevice;
              if ($tradeInValueAmounts?.length) {
                $tradeInValueAmounts.forEach(($tradeInValueAmount) => {
                  $tradeInValueAmount.innerText = `${formatPriceWithoutCurrency(tradeInValueEstimated).replace('.00', '')}`;
                  $tradeInValueAmount.parentElement?.classList?.remove('hidden');
                });
              }

              if ($startTradeInBtnLabel && $startTradeInBtn) {
                $startTradeInBtnLabel.innerText = 'Edit trade-in';
                $startTradeInBtn.setAttribute('checked', 'checked');
              }
            }

            if ($tradeInModalCloseBtn) $tradeInModalCloseBtn.click();
            if ($tradeInModalCloseBtn2) $tradeInModalCloseBtn2.click();

            if ($productPrices?.length) {
              $productPrices.forEach(($productPrice) => {
                const { priceWithoutCurrency } = $productPrice.dataset;
                let price = parseInt(priceWithoutCurrency.replace(',', ''));
                let parsedValue = parseInt(priceWithoutCurrency.replace(',', ''))
                if (parsedValue < tradeInValueEstimated) {
                  price = 0;
                } else {
                  price = parsedValue - tradeInValueEstimated;
                }
                $productPrice.setAttribute('data-price-with-trade-in', `${price} THB`);
              });
            }

            if(document.querySelector('cto-header')) {
              updatePriceCTOAfterAddingTradeIn()
            } else {
              updatePriceAfterAddingTradeIn()
            }
          });
        });

                // Update product price and NMP price after adding trade-in
        function updatePriceCTOAfterAddingTradeIn(productPriceEl) {
          const $productPrices = document.querySelectorAll('.two-price .js-product-price-with-care-warranty, .cto-summary__price-wrapper .js-product-price-with-care-warranty, .js-sticky-atc-mobile .js-product-price-with-care-warranty');
          $productPrices.forEach((productPriceEl) => {
            const isAppleCareAdded = $('#add-apple-care').is(':checked');
            const isWarrantyAdded = $('#add-secWarranty').is(':checked');
            const hiddenSelectedTradeInValue = $('#selected-trade-in-value').val();
            const isTradeInAdded = parseFloat(hiddenSelectedTradeInValue) > 0;
            const ctoTradeInSelectedOption = $('.cto-trade-in .js-cto-trade-in-selected-option');

            const price = $(productPriceEl).attr('data-price');
            const isNMP = !$(productPriceEl).hasClass('cto_actual_price_bold');
            console.log("Current element", isNMP)
            const parents = $(productPriceEl).parents();
            const productPrice = $(parents).find('.cto-header__price') || $(parents).find('.two-price .net-monthly-pricing');
            const isFooterPrice = $(parents).find('.two-price .net-monthly-pricing') || null;
            const priceChildren = $(productPrice).children();
            const actualPrice = productPriceEl;
            const priceWithTradeIn = $(productPriceEl).attr('data-price-with-trade-in');
            const actualPriceWithTradeIn = $(actualPrice).attr('data-price-with-trade-in');
            const nmpPriceCalculationEl = $(actualPrice).attr('data-price-calculation');
            const nmpPriceCalculation = nmpPriceCalculationEl ? parseInt(nmpPriceCalculationEl) : 0;
            let tempPrice;
            let dataPrice;
            let updatedPrice;
            console.log("value",$(productPriceEl), actualPriceWithTradeIn)

            if (isTradeInAdded && isAppleCareAdded && isWarrantyAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-care-and-secWarranty', productPriceEl);
            } else if (isTradeInAdded && isAppleCareAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-care', productPriceEl);
            } else if (isTradeInAdded && isWarrantyAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-secWarranty', productPriceEl);
            } else if (isTradeInAdded && isFooterPrice) {
              if (isNMP) {
                tempPrice = formatMoney(actualPriceWithTradeIn);
                updatedPrice = formatPriceWithoutCurrency((tempPrice / nmpPriceCalculation).toFixed(2));
              } else {
                tempPrice = formatMoney(priceWithTradeIn);
                updatedPrice = formatPriceWithCurrency(tempPrice);
              }
            } else {
              updatedPrice = price;
            }
            $(productPriceEl).html(updatedPrice);
            $(ctoTradeInSelectedOption).text('Trade-in');

            // update cto header price
            console.log(productPrice)
            updateCTOHeader(productPriceEl, updatedPrice);
          })
        }

        function updateCTOHeader(el, price) {
          if (!el && !price) return;

          const $dynamicPrice = $('.js-cto-from-pricing');
          const $dynamicNoFromPrice = $('.js-cto-dynamic-pricing');
          const $dynamicMonthlyPrice = document.querySelectorAll('.js-cto-dynamic-pricing-monthly');

          if ($dynamicPrice && $dynamicPrice.length) {
            const hasParentWithClass = $(el).closest('.js-cto-summary-price')?.length > 0;
            if (hasParentWithClass) {
              const productPriceText = SDG.Data.productPriceFrom.replace(`\{\{ price \}\}`, price);

              $($dynamicPrice).each((i, $price) => {
                $($price).html(productPriceText);
              });

              $($dynamicNoFromPrice).each((i, $price) => {
                $($price).html(price);
              });
            }

            if ($dynamicMonthlyPrice?.length > 0) {
              const monthlyParent = $(el).closest('.net-monthly-pricing')?.length > 0;

              [...$dynamicMonthlyPrice].forEach($price => {
                const val = $price.querySelector('.js-product-price-with-care-warranty');

                if (monthlyParent && val) {
                  val.innerHTML = price;
                }
              });
            }
          }
        }


        // Update product price and NMP price after adding trade-in
        function updatePriceAfterAddingTradeIn() {
          const isAppleCareAdded = $('#add-apple-care').is(':checked');
          const isWarrantyAdded = $('#add-secWarranty').is(':checked');
          const hiddenSelectedTradeInValue = $('#selected-trade-in-value').val();
          const isTradeInAdded = parseFloat(hiddenSelectedTradeInValue) > 0;

          $('.js-product-price-with-care-warranty').each(function (i, $productPrice) {
            const price = $($productPrice).attr('data-price');
            const isNMP = !$($productPrice).hasClass('actual_price_bold');
            const parents = $($productPrice).parents();
            const productPrice = $(parents).find('.price.price-product-pdp');
            const priceChildren = $(productPrice).children();
            const actualPrice = $(priceChildren).find('.js-product-price-with-care-warranty.actual_price_bold');
            const priceWithTradeIn = $($productPrice).attr('data-price-with-trade-in');
            const actualPriceWithTradeIn = $(actualPrice).attr('data-price-with-trade-in');
            const nmpPriceCalculationEl = $(actualPrice).attr('data-price-calculation');
            const nmpPriceCalculation = nmpPriceCalculationEl ? parseInt(nmpPriceCalculationEl) : 0;
            let tempPrice;
            let dataPrice;
            let updatedPrice;

            if (isTradeInAdded && isAppleCareAdded && isWarrantyAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-care-and-secWarranty', $productPrice);
            } else if (isTradeInAdded && isAppleCareAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-care', $productPrice);
            } else if (isTradeInAdded && isWarrantyAdded) {
              updatedPrice = setPriceWithTradeIn('data-price-with-secWarranty', $productPrice);
            } else if (isTradeInAdded) {
              if (isNMP) {
                tempPrice = formatMoney(actualPriceWithTradeIn);
                updatedPrice = formatPriceWithoutCurrency((tempPrice / nmpPriceCalculation).toFixed(2));
              } else {
                tempPrice = formatMoney(priceWithTradeIn);
                updatedPrice = formatPriceWithCurrency(tempPrice);
              }
            } else {
              updatedPrice = price;
            }

            $($productPrice).html(updatedPrice);
          });
        }
    }
    // Trade-In Modal Select/Radio options
    document.addEventListener('DOMContentLoaded',() => {
      var clicked = false
      // Avoid loading CompAsia API until open modal
      const $tradeInModalTriggerInput = document.querySelectorAll('.js-trade-in-modal-trigger-input, .js-trade-in-modal-trigger');
      if ($tradeInModalTriggerInput) {
        $tradeInModalTriggerInput.forEach(i => i.addEventListener('click', () => {
            if (clicked === false) {
              clicked = true
            initTradein();
            } else {
              const $tradeInModals = document.querySelectorAll('.trade-in__modal-content:not(.imei-step)');
                $tradeInModals.forEach( async ($modal) => {

                  // Reset to step 1 modal
                  $modal.querySelector('[data-step-1]').classList.remove("no-js")
                  $modal.querySelector('[data-step-2]').classList.add("no-js")
                  $modal.querySelector('[data-step-3]').classList.add("no-js")

                  $modal.querySelector(".rollback-imei-trigger").classList.add('no-js')
                  $modal.querySelector('.fake-trigger').classList.add("no-js")
                  // End remove to step 1 modal
              })
            }
          }))
      }
    }, false);

    // Trade In Learn More Modals
    function initTradeInModals() {
      const $tradeInLearnMoreModals = document.querySelectorAll('[id^="modal-trade-in-learn-more-modal"]');
      const $tradeInLearnMoreModalTriggers = document.querySelectorAll(
        '.js-trade-in-learn-more-modal-trigger:not(.event-attached)'
      );

      $tradeInLearnMoreModalTriggers.forEach(($tradeInLearnMoreModalTrigger) => {
        if (!$tradeInLearnMoreModals.length) return;

        $tradeInLearnMoreModalTrigger.classList.add('event-attached');
        // Close previous Learn More modal
        $tradeInLearnMoreModalTrigger.addEventListener('click', () => {
          const $tradeInLearnMoreModal = document.getElementById($tradeInLearnMoreModalTrigger.dataset.modalTarget);
          const $tradeInLearnMoreModalParent = $tradeInLearnMoreModal.parentElement;
          const $tradeInLearnMoreModalClose = $tradeInLearnMoreModalParent
            ? $tradeInLearnMoreModalParent.nextElementSibling
            : null;

          if (!$tradeInLearnMoreModalClose) return;

          const $tradeInModalTrigger = $tradeInLearnMoreModal.querySelector('.js-trade-in-modal-trigger');

          $tradeInModalTrigger.addEventListener('click', () => {
            $tradeInLearnMoreModalClose.click();
          });
        });

        // Allow a secondary trade in modal trigger on the PDP
        const $tradeInModalTriggerInput = document.querySelector('.js-trade-in-modal-trigger-input');
        const $tradeInModalTrigger = document.querySelector('.ac-modal-trigger.js-trade-in-modal-trigger');
        if ($tradeInModalTriggerInput && $tradeInModalTrigger) {
          $tradeInModalTriggerInput.addEventListener('click', () => {
            $tradeInModalTrigger.click();
            
          });
        }
      });

      // Allow a secondary trade in modal trigger on the cart page
      const $tradeInModalSecondaryCartTriggers = document.querySelectorAll('.js-trade-in-modal-trigger-secondary-cart');
      $tradeInModalSecondaryCartTriggers.forEach(($tradeInModalSecondaryCartTrigger) => {
        $tradeInModalSecondaryCartTrigger.addEventListener('click', () => {
          const $primaryTrigger = document.querySelector(
            `.ac-modal-trigger.js-trade-in-modal-trigger[data-modal-target="${$tradeInModalSecondaryCartTrigger.dataset.modalTarget}"]`
          );
          if ($primaryTrigger) {
            $primaryTrigger.click();
          }
        });
      });
    }
    document.addEventListener('DOMContentLoaded', initTradeInModals, false);

    if (document.querySelector("#no-trade-in")) document.querySelector("#no-trade-in").addEventListener("click", () => {
      const $tradeInValueAmounts = document.querySelectorAll('.js-trade-in-value-amount');
      const $startTradeInBtn = document.querySelector('.js-product-option-form .js-trade-in-modal-trigger-input');
      const $startTradeInBtnLabel = document.querySelector('.js-product-option-form .js-trade-in-modal-trigger-input + label');
      const $ctoTradeInSelectedOption = document.querySelector('.cto-trade-in .js-cto-trade-in-selected-option');
      const $hiddenSelectedTradeIn = document.querySelector('#selected-trade-in-value');
      const $summaryText = document.querySelector('.js-cto-summary-trade-in') || null;

      $tradeInValueAmounts.forEach(($tradeInValueAmount) => {
        if ($tradeInValueAmount.classList?.contains('pdp-value-amount')) {
          $tradeInValueAmount.innerText = '฿0';
          $tradeInValueAmount.setAttribute('data-trade-in-value', 0);
          $tradeInValueAmount.parentElement?.classList?.add('hidden');
        }
      });

      
      $startTradeInBtnLabel.innerText = "Start trade-in";
      $ctoTradeInSelectedOption.innerText = "No trade-in";
      $hiddenSelectedTradeIn.value = 0;

      if ($summaryText) {
        $summaryText.classList.add('hidden');
      }
      updatePriceAfterRemovingTradeIn();
    });

    function updatePriceAfterRemovingTradeIn() {
      const isAppleCareAdded = $('#add-apple-care').is(':checked');
      const isWarrantyAdded = $('#add-secWarranty').is(':checked');
      const isTradeInAdded = document.querySelector('#selected-trade-in-value')?.value;
      const $productPrices = document.querySelectorAll('.two-price .js-product-price-with-care-warranty, .cto-summary__price-wrapper .js-product-price-with-care-warranty');

      $($productPrices).each((i, $productPrice) => {
        const price = $($productPrice).data('price');
        const parents = $($productPrice).parents();
        const productPrice = $(parents).find('.cto-header__price') || $(parents).find('.two-price .net-monthly-pricing');
        const isFooterPrice = $(parents).find('.two-price .net-monthly-pricing') || null;
        let updatedPrice;

        if (isTradeInAdded && isAppleCareAdded && isWarrantyAdded) {
          updatedPrice = $($productPrice).attr('data-price-with-care-and-secWarranty');
        } else if (isTradeInAdded && isAppleCareAdded) {
          updatedPrice = $($productPrice).attr('data-price-with-care');
        } else if (isTradeInAdded && isWarrantyAdded) {
          updatedPrice = $($productPrice).attr('data-price-with-secWarranty');
        } else if (isTradeInAdded && isFooterPrice) {
          updatedPrice = price;
        } else {
          updatedPrice = price;
        }

        $($productPrice).html(updatedPrice);
      });
    }
  